module.exports = __webpack_public_path__ + "img/interpackmaxi-inactive.4d960a5e.svg";